import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSynonymsLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.7998 0C5.48266 0 2.7998 2.504 2.7998 5.6C2.7998 9.8 8.7998 16 8.7998 16C8.7998 16 14.7998 9.8 14.7998 5.6C14.7998 2.504 12.1169 0 8.7998 0ZM4.51409 5.6C4.51409 3.392 6.43409 1.6 8.7998 1.6C11.1655 1.6 13.0855 3.392 13.0855 5.6C13.0855 7.904 10.6169 11.352 8.7998 13.504C7.01695 11.368 4.51409 7.88 4.51409 5.6Z",
		fill: "#1C2D3B"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.7998 7.6C9.90437 7.6 10.7998 6.70457 10.7998 5.6C10.7998 4.49543 9.90437 3.6 8.7998 3.6C7.69524 3.6 6.7998 4.49543 6.7998 5.6C6.7998 6.70457 7.69524 7.6 8.7998 7.6Z",
		fill: "#1C2D3B"
	})]
});
export default SvgSynonymsLocation;
